module.exports = __webpack_public_path__ + "img/BAU Seniors_24.11011087.jpg";